import { GoogleMap, InfoWindow, Marker, OverlayView, useJsApiLoader } from "@react-google-maps/api";
import VeiculoViagemRastreamentoItem from "model/gestao/frotas/VeiculoViagemRastreamentoItem";
import { useEffect, useState } from "react";
import VeiculoViagemRastreamentoService from "service/gestao/frotas/VeiculoViagemRastreamentoService";
import { converterDataHora } from "utils/convert";
import "./VeiculoViagemMap.scss";

const service = new VeiculoViagemRastreamentoService();
export default function VeiculoViagemRastreamentoPage() {

    const keyMaps = 'AIzaSyDQbLYImEY_K1U92ocx6-e46qC2AjskIfo';
    const [center, setCenter] = useState({ lat: -15.595992, lng: -56.092860 }); //cuiabá
    const [hover, setHover] = useState<boolean[]>([]);

    const [itensRastreados, setitensRastreados] = useState<VeiculoViagemRastreamentoItem[]>([]);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: keyMaps,
    })

    useEffect(() => {
        service.getRastreamento().then((data) => {
            setitensRastreados(data);
            setHover(new Array(data.length).fill(false));
            if (data.length > 0) {
                setCenter({ lat: data[0].ultimoPonto!.latitude, lng: data[0].ultimoPonto!.longitude });
            }
        }).catch((error) => {
            console.error(error);
        });
    }, [])

    const loadInterval = 5 * 1000; // 5 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            load();
        }, loadInterval);
        return () => clearInterval(interval);
    }, [])

    const load = () => {
        service.getRastreamento().then((data) => {
            setitensRastreados(data);
            setHover(new Array(data.length).fill(false));
            
        }).catch((error) => {
            console.error(error);
        });
    }

    const [map, setMap] = useState<google.maps.Map | null>(null)

    const listaFlutuante = <div style={{
        display: "flex", flexDirection: "column", zIndex: 100, position: "fixed",
        padding: 10, backgroundColor: "white", borderRadius: 5
    }}>
        <h3 style={{ textAlign: "center" }}>Veículos</h3>
        {itensRastreados.length === 0 && <div style={{ textAlign: "center" }}>Nenhum veículo em percurso</div>}
        {itensRastreados.map((item, index) => {
            return <div key={index} onClick={() => {
                setCenter({ lat: item.ultimoPonto!.latitude, lng: item.ultimoPonto!.longitude });
            }} style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", borderBottom: "1px solid #ccc", padding: 5, cursor: "pointer" }}>
                <div>{item.veiculoViagem!.veiculo?.modelo} - {item.veiculoViagem!.veiculo?.placa}</div>
                <div>{item.veiculoViagem!.motorista?.nome} - {item.veiculoViagem!.motorista?.numeroDocumento}</div>
                <div><b>Última atualização:</b> {converterDataHora(item.ultimoPonto!.dataHora)}</div>
            </div>
        })}
    </div>

    const formatarDistancia = (distancia: number | undefined) => {
        if (!distancia) return "";
        return (distancia / 1000).toFixed(1).replace(".", ",") + " km"
    }

    return (
        <div>
            {listaFlutuante}
            <div style={{ width: "100%", top: 0, left: 0, position: "absolute", zIndex: 1 }}>

                {isLoaded ? <GoogleMap
                    onLoad={(map) => {
                        const bounds = new window.google.maps.LatLngBounds(center)
                        map.fitBounds(bounds)
                        var listener = google.maps.event.addListener(map, "idle", function () {
                            if ((map.getZoom() || 0) > 15) map.setZoom(15);
                            google.maps.event.removeListener(listener);
                        })
                        setMap(map);
                    }}
                    zoom={15}
                    center={center}
                    onUnmount={() => { }}
                    mapContainerStyle={{
                        height: "100vh",
                        width: "100%"
                    }}
                >
                    {itensRastreados.map((item, index) => {
                        const position = { lat: item.ultimoPonto!.latitude, lng: item.ultimoPonto!.longitude };
                        return <>
                            <Marker
                                position={position}
                                onMouseOver={() => {
                                    const newHover = [...hover];
                                    newHover[index] = true;
                                    setHover(newHover);
                                }}
                                onMouseOut={() => {
                                    const newHover = [...hover];
                                    newHover[index] = false;
                                    setHover(newHover);
                                }}
                            />

                            {
                                hover[index] && (
                                    <InfoWindow
                                        position={position}
                                        options={{
                                            disableAutoPan: true,
                                            pixelOffset: new window.google.maps.Size(0, -40),
                                        }}
                                    >
                                        <div style={styles.card}>
                                            <div style={{ fontWeight: "bold", fontSize: 14 }}>{item.veiculoViagem?.motorista?.nome}</div>
                                            <div>Placa: {item.veiculoViagem?.veiculo?.placa}</div>
                                            <div>Última atualização: {converterDataHora(item.ultimoPonto!.dataHora)}</div>
                                            <div style={{ fontWeight: "bold" }}>
                                                Distância percorrida: {formatarDistancia(item.veiculoViagem?.distanciaPercorrida)}
                                            </div>
                                        </div>
                                    </InfoWindow>
                                )
                            }
                        </>
                    })}
                </GoogleMap> : null}
            </div>
        </div>

    )
}

const styles: { [key: string]: React.CSSProperties } = {
    card: {
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        gap: 4
    },
};